import { Component } from "react"
import PropTypes from "prop-types"
import { map } from "lodash"
import { Collapse, IconButton } from "@mui/material"
import { ExpandMore, StarRounded } from "@mui/icons-material"
import classnames from "classnames"
import NewFeature from "modules/new-feature"
import Row from "./row"
import "./styles.scss"

export default class CompareTablePanel extends Component {
  static propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      noData: PropTypes.bool,
      isUmodeled: PropTypes.bool,
    })).isRequired,
    item: PropTypes.shape({
      label: PropTypes.string,
      color: PropTypes.string,
      defaultOpen: PropTypes.bool,
      fn: PropTypes.func,
      newFeature: PropTypes.string,
      fixGap: PropTypes.bool,
      items: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        fn: PropTypes.func.isRequired,
      })),
    }).isRequired,
    data: PropTypes.array.isRequired,
    trackPanelTrigger: PropTypes.func.isRequired,
    fixedItemNumber: PropTypes.bool,
  }

  constructor(props, ...args) {
    super(props, ...args)

    this.state = {
      open: !!props.item.defaultOpen,
    }
  }

  toggle = () => {
    const { trackPanelTrigger, item: { label } } = this.props
    trackPanelTrigger(label)
    this.setState(state => ({ open: !state.open }))
  }

  renderLabel({ isFixed }) {
    const { item: { label, fn, color, newFeature }, data, columns, fixedItemNumber } = this.props
    if (!label) {
      return null
    }

    let panel = (
      <div style={{ color, fontWeight: "bold" }} data-test-class="compare-section-label" className="panel-label">
        {label}
        {!isFixed && <IconButton className="expand-icon" component="div" tabIndex={-1} size="large"><ExpandMore /></IconButton>}
      </div>
    )
    if (newFeature) {
      panel = (
        <NewFeature id={newFeature}>{panel}</NewFeature>
      )
    }

    return (
      <div className={classnames("panel-row", "title-row", { "fixed-item-number": fixedItemNumber })}>
        {panel}
        {map(columns, (column, index) => <Row key={index} column={column} data={data} index={index} selector={fn} />)}
      </div>
    )
  }

  render() {
    const { item: { label, fn, items, color, fixGap }, data, columns, fixedItemNumber } = this.props
    const { open } = this.state

    const isFixed = (!label && !fn) || !items
    const isOpen = open || (!label && !fn)

    return (
      <div className={classnames("components_compare-collapse-panel", { expanded: isOpen, fixed: isFixed, fixGap })} onClick={isFixed ? null : this.toggle}>
        <Collapse collapsedSize={48} in={isOpen} data-test-class="compare-section-summary">
          <div style={{ backgroundColor: color, position: "absolute", width: 10, height: "100%", top: 0, left: 0 }} />
          {this.renderLabel({ isFixed })}
          {map(items, ({ label, fn, favorite }, index) => <div key={index} data-test-class="compare-section-row" className={classnames("panel-row", { "fixed-item-number": fixedItemNumber })}>
            <div data-test-class="compare-section-row-label" className={classnames({ "panel-label": isFixed, "row-label": !isFixed, favorite })}>
              <StarRounded className="star-icon" style={{ color }} />{label}
            </div>
            {map(columns, (column, index) => <Row key={index} column={column} data={data} index={index} selector={fn} />)}
          </div>)}
        </Collapse>
      </div>
    )
  }
}
